import LoadablePageTree from './loadable_page_tree'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadablePageTree, 'Modulor.PageTree')
